<template>
    <div class="page" :style="pageStyle.style">
        <div class="login">
            <div class="login-form">
                <p class="login-title">登录账号</p>
                <a-input v-model:value="account" placeholder="用户名">
                    <template #prefix><UserOutlined style="color: rgba(0, 0, 0, 0.25)" /></template>
                </a-input>
                <a-input v-model:value="password" type="password" placeholder="密码">
                    <template #prefix><LockOutlined style="color: rgba(0, 0, 0, 0.25)" /></template>
                </a-input>
                <a-button @click="onSubmit" class="sub-btn">登录</a-button>
                <a-button @click="onRegister" class="reg-btn">注册</a-button>
                <p class="forget-pwd" @click="retrievePWD">忘记密码？</p>
            </div>
        </div>
    </div>
    <ForgetPWD
        :visible="modalVisible"
        @reset="resetSuccess"
    ></ForgetPWD>
</template>

<script>
import {ref, onMounted, reactive} from "@vue/runtime-dom"
import { UserOutlined, LockOutlined } from '@ant-design/icons-vue'
import {loginApi} from '@/api/login'
import Cookies from 'js-cookie'
import router from "@/router"
import {notification} from "ant-design-vue"
import ForgetPWD from "@/views/portal/ForgetPWD"
export default {
    name: "Login",
    created() {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const lett = this
        document.onkeydown = function(e) {
            const key = window.event.keyCode
            if (key == 13) {
                lett.onSubmit()
            }
        }
    },
    setup() {
        const account = ref('')
        const password = ref('')
        const modalVisible = ref(false)
        const pageStyle = reactive({
            style: {}
        })
        const onSubmit = async () => {
            const params = {
                account: account.value,
                password: password.value,
                grantType: 'password'
            }
            const res = await loginApi(params)
            if (res) {
                Cookies.set('Token', JSON.stringify(res.token), { expires: 1 })
                Cookies.set('userInfo', JSON.stringify(res), { expires: 1 })
                notification.success({ message: '登录成功!', description: '', duration: 2 })
                setTimeout(() => {
                    router.back(-1)
                }, 2000)
            }
        }
        onMounted(() => {
            pageStyle.style = { height: window.innerHeight+'px', width: window.innerWidth + 'px'}
        })
        return {
            account,
            password,
            pageStyle,
            modalVisible,
            onSubmit,
            // onRegister
        }
    },
    methods: {
        onRegister() {
            router.push({name: '/portal/MingLuAdd'})
        },
        retrievePWD() {
            this.modalVisible = true
        },
        resetSuccess() {
            this.modalVisible = false
        }
    },
    components: {
        UserOutlined,
        LockOutlined,
        ForgetPWD
    }
}
</script>

<style scoped lang="stylus">
    .page {
        width 100%
        height 100%
        position relative
        background #FFF
        background-image url("../../assets/img/login_pc_bg.png")
        background-size cover
        background-repeat no-repeat
        display flex
        justify-content center
        align-items center
        .login {
            width 1550px
            height 890px
            background #d9d9d9
            background-image url("../../assets/img/login_pc_bg_center.png")
            background-size 100% 100%
            background-repeat no-repeat
            box-shadow 0 6px 46px rgba(15, 98, 134, 0.15)
            border-radius 6px
            padding 100px
            display flex
            justify-content flex-end
            .login-form {
                width 560px
                .login-title {
                    margin 100px 0
                    width 100%
                    text-align center
                    font-size 36px
                    color #128BF1
                    font-weight 500
                }
                .forget-pwd {
                    text-align right
                    color #C0C8CD
                    font-size 16px
                    cursor pointer
                }
            }
            .login-form >>> .ant-input-affix-wrapper > input.ant-input {
                padding 20px
                background none
                font-size 24px
            }
            .login-form >>> .ant-input-affix-wrapper-focused {
                box-shadow none
            }
            .login-form >>> .ant-input-affix-wrapper {
                border-bottom 1px solid #CCC
                border-left none
                border-top none
                border-right none
                border-radius 0
                background none
                font-size 24px
            }
            .login-form >>> .ant-btn {
                width 350px
                background #128BF1
                height 50px
                line-height 45px
                font-size 24px
                display block
                color #FFF
                margin 25px auto
            }
        }
    }
</style>